
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
    selector: 'app-planilha-input-diretos-extra',
    templateUrl: './planilha-input-diretos-extra.component.html',
    styleUrls: ['./planilha-input-diretos-extra.component.css'],
    standalone: false
})

export class PlanilhaInputDiretosExtraComponent {
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  // query: string = 'itens_Interplantas_Karrara';
  queryDiretasExtras: string = "Viagens-Diretas-Extras";
  queryTimeTable: string = 'janelasTimeTable';
  // queryDiretas: string = "Viagens-Diretas";
  queryFornecedores: string = 'Tb_Supplier_New';
  startDate!: Date;
  endDate: Date = new Date();
  editMode!: boolean[];
  informationMode!: boolean[];
  dialogOpen!: boolean;
  places!: any[];
  transportadora!: string[];
  locais!: string[];
  isLoading: boolean = true;
  viagensDiretas!: any[];
  viagensDiretasExtras: any[] = [];
  inputViagens: any[] = [];
  horarios: string[] = [
    "07:00",
    "07:00",
    "08:00",
    "08:00",
    "09:00",
    "09:00",
    "10:00",
    "10:00",
    "12:00",
    "12:00",
    "13:00",
    "13:00",
    "14:00",
    "14:00",
    "15:00",
    "15:00",
    "18:00",
    "18:00",
    "19:00",
    "19:00",
    "20:00",
    "20:00",
    "21:00",
    "21:00",
    "22:00",
    "22:00",
    "23:00",
    "23:00",
    "23:50",
    "23:50"
  ];
  recebimentos: string[] = [
    "R27",
    "R29",
    "R16",
    "R4",
    "R40",
    "R54",
    "E56",
    "R56",
    "E37",
    "R43",
    "R22"
  ];
  dataReferencia!: Date;
  dataFormatada!: string;
  viagensDiretasExtrasFiltrados!: any[];
  viagensDiretasExtrasZerada!: any[];
  item: any = {};
  usuarioLogado!: UsuarioLogado;
  filtro: boolean = false;
  desabilitado: boolean = false;
  totalMU: number = 0;
  totalFornecedores: number = 0;
  // pecasCritica: [
  //   {
  //     PN: '';
  //     quantidade: 0;
  //   }
  // ] = [{PN: '', quantidade:0}];

  constructor(
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private autenticacaoService: AutenticacaoService
  ) {

  }

  async ngOnInit() {
    this.usuarioLogado = await this.getUserLogado();
    await this.upDate();
  }

  async upDate() {
    let dataAtual = new Date();
    // console.log(dataAtual)
    await this.resetaVariavel(dataAtual);
    // await this.getDiretas();
    await this.getDiretasExtras();
    await this.getPlacesFromDynamoDB();
    this.isLoading = false;
  }

  async resetaVariavel(data: Date) {
    // console.log(data)

    this.viagensDiretasExtrasZerada = []
    let dataAtual = data;

    if (this.filtro) {
    // console.log('this.filtro')
      this.dataReferencia = new Date(dataAtual);
      this.dataReferencia.setDate(dataAtual.getDate());
      const ano = this.dataReferencia.getFullYear();
      const mes = String(this.dataReferencia.getMonth() + 1).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
      const dia = String(this.dataReferencia.getDate()).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
      this.dataFormatada = `${ano}-${mes}-${dia}`;
    } else {
      // let dataAtual = new Date();
      const horaAtual = dataAtual.getHours();
      // if (horaAtual < 15) {
        this.dataReferencia = new Date(dataAtual);
        // this.dataReferencia.setDate(dataAtual.getDate() + 1);
        this.dataReferencia.setDate(dataAtual.getDate());
        const ano = this.dataReferencia.getFullYear();
        const mes = String(this.dataReferencia.getMonth() + 1).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        const dia = String(this.dataReferencia.getDate()).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        this.dataFormatada = `${ano}-${mes}-${dia}`;
      // } else {
        // Se a hora atual for após as 15:00, this.dataReferencia é dois dias após a data atual
        // this.dataReferencia = new Date(dataAtual);
        // // this.dataReferencia.setDate(dataAtual.getDate() + 2);
        // this.dataReferencia.setDate(dataAtual.getDate());
        // const ano = this.dataReferencia.getFullYear();
        // const mes = String(this.dataReferencia.getMonth() + 1).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        // const dia = String(this.dataReferencia.getDate()).padStart(2, '0'); // Adiciona o zero à esquerda se necessário
        // this.dataFormatada = `${ano}-${mes}-${dia}`;
      // }
    }
    for (let i = 0; i < 30; i++) {
      await this.viagensDiretasExtrasZerada.push({
        dataSolicitacao: this.dataFormatada,
        horario: this.horarios[i],
        mpCode: '',
        mpName: '',
        codFronecedor: '',
        fornecedor: '',
        volumes: '',
        localRecebimento: '',
        status: 'NOT OK',
        indice: i // Certifique-se de adicionar o índice ao novo item
      });
    }
    // console.log(this.viagensDiretasExtrasZerada)

  }

  editDialog(item: any, i: number): void {
    // console.log(item)
    // this.item.pecasCritica = {PN: '', quantidade:0};
    this.item = { ...item };
    this.item.indice = i;
    this.item.pecasCritica = this.item.pecasCritica || [];
    this.dialogOpen = true;
  }

  adicionarPecasCritica() {
    this.item.pecasCritica.push({ PN: '', quantidade: 0 });
  }

  removerPecasCritica(index: number) {
    this.item.pecasCritica.splice(index, 1);
  }

  selecionarTexto(event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
  }

  async salvar2() {
    this.isLoading = true;
    const currentDate = new Date().getTime();
    if (!this.item.ID || this.item.ID == undefined || this.item.ID == null || this.item.ID == '') {
      this.item.ID = this.item.indice;
      const time = Date.now();
      this.item.ID = `${this.item.ID}${time}`;
      this.item.created = currentDate.toString();
      this.item.date =  new Date();
    } else {
      this.item.ID = this.item.ID
    }
    this.item.tableName = this.queryDiretasExtras
    this.item.origemExtraScania = true
    // console.log(this.item)
    const itemsDataString = JSON.stringify(this.item);
    const modifiedString = itemsDataString.replace(/\\"/g, '"');
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    const modifiedJsonString = JSON.stringify(jsonObject);
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonArray, this.item.tableName, this.urlAtualiza).subscribe(async response => {
      this.filtro = false;
      this.startDate = new Date();
      await this.upDate();
      await this.salvarNaTimeTable();
      // //console.log(response)
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async salvarNaTimeTable() {
    // console.log(this.item)
    // console.log(this.item.pecasCritica)
    const dataHoraString = `${this.item.dataSolicitacao}T${this.item.horario}:00.000Z`;
    const dataHora = new Date(dataHoraString);
    // console.log(dataHora)
    const formattedDate = dataHora.toISOString();
    // console.log(formattedDate)
    this.isLoading = true;
    this.item = {
      ...this.item,
      "ID": this.item.ID,
      "lastUpdate": new Date(),
      "date": new Date(),
      "dataJanelaTimeTable": this.item.dataSolicitacao,
      "dataJanela": this.item.dataSolicitacao,
      "horaJanelaTimeTable": this.item.horario,
      "JanelaDestino 1": formattedDate,
      "Transportadora": 'DIRETO EXTRA',
      // "Janela": formattedDate,
      // "jan1": formattedDate,
      "Plate": this.item.Plate,
      "Volumes": this.item.volumes,
      'Fornecedor 1': this.item.fornecedor,
      'Fornecedores': this.item.fornecedor,
      "tableName": this.queryTimeTable,
      'area': this.item.localRecebimento == "R29" ? 'R27' : this.item.localRecebimento,
      'prioridade': this.item.pecasCritica.length > 0 ? true : false,
      'Destino 1': 'SCANIA'
    }
    console.log(this.item)
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.upDate();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  cancel(): void {
    this.dialogOpen = false;
  }

  async getDiretasExtras(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": this.queryDiretasExtras,
        "searchConditions": [
          // { "column": "status", "word": "Completed", "negate": true },
          // { "column": "status", "word": "Canceled", "negate": true },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true },
          // { "column": "ID", "word": "", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = await JSON.parse(response.body);
          if (Array.isArray(items)) {
            if (this.usuarioLogado.role == '4') {
              this.viagensDiretasExtras  = items.filter(item => {
                return (item.fornecedor == this.usuarioLogado.company)
              })
            }else{
            this.viagensDiretasExtras = items;
            }
            // this.viagensDiretasExtras = items;
            this.viagensDiretasExtrasZerada.forEach((novaViagem, index) => {

              const indiceExistente = this.viagensDiretasExtras.findIndex(
                viagem => viagem.indice === novaViagem.indice && viagem.dataSolicitacao === novaViagem.dataSolicitacao
              );
              if (indiceExistente !== -1) {
                this.viagensDiretasExtrasZerada[index] = this.viagensDiretasExtras[indiceExistente];
              }
            });
            this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasZerada.filter(item => {
              const dataString = item.dataSolicitacao;
              const dataDate = new Date(this.dataReferencia).toISOString().split('T')[0];
              // console.log(dataString)
              // console.log(dataDate)
              return dataString === dataDate
            });
            this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasFiltrados.sort((a, b) => {
              const horaA = new Date('1970-01-01T' + a.horario).getTime(); // Convertendo para milissegundos
              const horaB = new Date('1970-01-01T' + b.horario).getTime(); // Convertendo para milissegundos                
              return horaA - horaB;
            });
            // console.log(this.viagensDiretasExtrasFiltrados)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }

    } catch (error: any) {
      console.error(error);
    }
  }

  async getPlacesFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.queryFornecedores, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.places = items;
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async aplicarFiltro(): Promise<void> {
    // console.log("filtro")
    // this.desabilitado = new Date(this.startDate) < new Date()
    // console.log(new Date(this.startDate))
    // console.log(new Date())
    // console.log(this.desabilitado)
    this.filtro = true;
    // console.log(this.startDate)
    let dataRef = new Date(this.startDate + 'T12:00:00');
    await this.resetaVariavel(dataRef);
    this.viagensDiretasExtrasZerada.forEach((novaViagem, index) => {
    // console.log(novaViagem)

      const indiceExistente = this.viagensDiretasExtras.findIndex(
        viagem => viagem.indice === novaViagem.indice && viagem.dataSolicitacao === novaViagem.dataSolicitacao
      );
    // console.log(indiceExistente)
      if (indiceExistente !== -1) {
    // console.log(indiceExistente)
        
        this.viagensDiretasExtrasZerada[index] = this.viagensDiretasExtras[indiceExistente];
    // console.log(this.viagensDiretasExtras[indiceExistente])
    // console.log(this.viagensDiretasExtrasZerada[index])
      }
    });
    // console.log(this.viagensDiretasExtrasFiltrados)
    // console.log(this.viagensDiretasExtrasZerada)

    this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasZerada.filter(item => {
      const dataString = item.dataSolicitacao;
      const dataDate = new Date(this.startDate).toISOString().split('T')[0];
      // console.log(dataString)
      // console.log(dataDate)
      return dataString === dataDate
    });
    // console.log(this.viagensDiretasExtrasFiltrados)

    this.viagensDiretasExtrasFiltrados = await this.viagensDiretasExtrasFiltrados.sort((a, b) => {
      const horaA = new Date('1970-01-01T' + a.horario).getTime(); // Convertendo para milissegundos
      const horaB = new Date('1970-01-01T' + b.horario).getTime(); // Convertendo para milissegundos                
      return horaA - horaB;
    });
    await this.somaMU();
  }

  somaMU() {
    this.totalMU = 0;
    this.totalFornecedores = 0;
    if (this.viagensDiretasExtrasFiltrados) {
      this.viagensDiretasExtrasFiltrados.forEach(item => {
        if (item.volumes > 0) {
          this.totalMU += parseFloat(item.volumes)
          this.totalFornecedores++;
        }
      })
    }
  }

  async limpaData() {
    this.filtro = false;
    // console.log(this.dataReferencia)
    this.startDate = new Date();
    await this.upDate();
    // this.viagensDiretasExtrasFiltrados = this.viagensDiretasExtrasZerada.filter(item => {
    //   const dataString = item.dataSolicitacao;
    //   const dataDate = new Date(this.dataReferencia).toISOString().split('T')[0];
    //   // console.log(dataString)
    //   // console.log(dataDate)
    //   return dataString === dataDate
    // });

    // this.viagensDiretasExtrasFiltrados = this.viagensDiretasExtrasFiltrados.sort((a, b) => {
    //   const horaA = new Date('1970-01-01T' + a.horario).getTime(); // Convertendo para milissegundos
    //   const horaB = new Date('1970-01-01T' + b.horario).getTime(); // Convertendo para milissegundos                
    //   return horaA - horaB;
    // });
  }

  verificarMPCode(item: any): void {
    const mpCodeUpperCase = item.mpCode.toUpperCase();
    const lugar = this.places.find(place => place.MP === mpCodeUpperCase);
    if (lugar) {
      item.mpName = lugar.MPName;
    } else {
      item.mpName = "";
    }
  }

  verificarFornecedor(item: any): void {
    const mpCodeUpperCase = item.codFronecedor.toUpperCase();
    const forn = this.places.find(place => place.SUPCode === mpCodeUpperCase);
    if (forn) {
      item.fornecedor = forn.SUPName;
    } else {
      item.fornecedor = "";
    }
  }

  async getUserLogado(): Promise<UsuarioLogado> {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    let usuario = await this.autenticacaoService.obterUsuarioLogado()
    return usuario;
    // //console.log(this.usuarioLogado)
  }

  toggleEditMode(index: number): void {
    this.editMode[index] = !this.editMode[index];
  }
  toggleInformationMode(index: number): void {
    this.informationMode[index] = !this.informationMode[index];
  }

  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryDiretasExtras).subscribe(
        async response => {
      this.startDate = new Date();
          await this.upDate();
          await this.deleteItemTimeTable(ID);
          this.isLoading = false;
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  async deleteItemTimeTable(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryTimeTable).subscribe(
        async response => {
          console.log("Deletado da tabela de extra Scania")
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }
}
